module.exports = __webpack_public_path__ + "static/media/kfc-dinein.e9e294c1.jpg";